import { isProductionHost } from './Env'

type EventPayload = Record<string, string | number | boolean | undefined>
type EventItem = { item_id: string; item_name: string; price: number }

const ADS_ID = import.meta.env.REACT_APP_GOOGLE_ADS_ID

const GOOGLE_ADS = {
  PURCHASE: import.meta.env.REACT_APP_GOOGLE_ADS_PURCHASE,
  INITIATE_CHECKOUT: import.meta.env.REACT_APP_GOOGLE_ADS_INITIATE_CHECKOUT,
  COMPLETE_REGISTRATION: import.meta.env.REACT_APP_GOOGLE_ADS_COMPLETE_REGISTRATION,
}

// Meta no reconoce el esquema de ecommerce de GA4 (items con item_id/item_name/price):
// espera content_ids/contents. Sin esta traducción, fbq recibiría "items" como un
// parámetro desconocido y lo ignoraría en silencio.
function toMetaContents(items: EventItem[]) {
  return {
    content_type: 'product',
    content_ids: items.map((item) => item.item_id),
    contents: items.map((item) => ({ id: item.item_id, quantity: 1, item_price: item.price })),
  }
}

function trackEvent(
  gaEventName: string,
  metaEventName: string,
  googleAdsLabel: string | undefined,
  payload?: EventPayload,
  items?: EventItem[],
) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', gaEventName, items ? { ...payload, items } : payload)

    if (googleAdsLabel && isProductionHost()) {
      window.gtag('event', 'conversion', {
        send_to: `${ADS_ID}/${googleAdsLabel}`,
        ...payload,
      })
    }
  }

  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', metaEventName, items ? { ...payload, ...toMetaContents(items) } : payload)
  }
}

export function trackCompleteRegistration() {
  trackEvent(
    'complete_registration',
    'CompleteRegistration',
    GOOGLE_ADS.COMPLETE_REGISTRATION
  )
}

export function trackInitiateCheckout(payload: { value: number; currency: string; items: EventItem[] }) {
  trackEvent(
    'begin_checkout',
    'InitiateCheckout',
    GOOGLE_ADS.INITIATE_CHECKOUT,
    { value: payload.value, currency: payload.currency },
    payload.items,
  )
}

export function trackPurchase(payload: {
  value: number
  currency: string
  transaction_id: string
  items: EventItem[]
}) {
  trackEvent(
    'purchase',
    'Purchase',
    GOOGLE_ADS.PURCHASE,
    { value: payload.value, currency: payload.currency, transaction_id: payload.transaction_id },
    payload.items,
  )
}

export function trackSelectItem(payload: { value: number; currency: string; items: EventItem[] }) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', 'select_item', { value: payload.value, currency: payload.currency, items: payload.items })
  }
}

export function trackRegistrationProgress(step: string) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', 'registration_progress', { step })
  }
}

export function setGtagUserId(userId?: string | null) {
  if (userId && typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('set', { user_id: userId })
  }
}
